import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';

export default function Billing() {
  const [charges, setCharges] = useState(null);
  const [paying, setPaying] = useState(null);
  const [error, setError] = useState(null);

  const params = new URLSearchParams(window.location.search);
  const justPaid = params.get('paid') === '1';
  const canceled = params.get('canceled') === '1';

  useEffect(() => {
    api('/billing/charges').then(setCharges).catch(() => setCharges([]));
    if (justPaid || canceled) window.history.replaceState({}, '', '/billing');
  }, []);

  const payNow = async (chargeId) => {
    setPaying(chargeId);
    setError(null);
    try {
      const { url } = await api(`/billing/charges/${chargeId}/checkout`, { method: 'POST' });
      window.location.href = url;
    } catch (e) {
      setError(e.message);
      setPaying(null);
    }
  };

  const statusColor = (status) => status === 'paid' ? 'var(--green)' : status === 'overdue' ? 'var(--red)' : 'var(--text-dim)';

  return (
    <div>
      <PageHeader
        icon={Icon.accounting}
        title="Billing"
        subtitle="Your TruckFlow subscription charges"
        color={SECTION_COLOR.accounting}
      />

      {justPaid && <div className="panel" style={{ marginBottom: 16, borderColor: 'var(--green)', color: 'var(--green)' }}>Payment received — thank you! It may take a minute to show as paid below.</div>}
      {canceled && <div className="panel" style={{ marginBottom: 16, color: 'var(--text-dim)' }}>Checkout was canceled — nothing was charged.</div>}
      {error && <div className="panel" style={{ marginBottom: 16, borderColor: 'var(--red)', color: 'var(--red)' }}>{error}</div>}

      {charges === null && <div className="empty">Loading...</div>}
      {charges && charges.length === 0 && <div className="empty">No charges yet.</div>}

      {charges && charges.length > 0 && (
        <table>
          <thead>
            <tr><th>Period</th><th>Amount</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {charges.map(c => (
              <tr key={c.id}>
                <td>{c.period_start} → {c.period_end}</td>
                <td>${Number(c.amount).toFixed(2)}</td>
                <td style={{ color: statusColor(c.status), fontWeight: 600, textTransform: 'capitalize' }}>{c.status}</td>
                <td>
                  {c.status !== 'paid' && (
                    <button className="primary-btn" onClick={() => payNow(c.id)} disabled={paying === c.id}>
                      {paying === c.id ? 'Redirecting...' : 'Pay Now'}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
